/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Attribute_Task_ExistsInputs */

const en_error_attribute_task_exists = /** @type {(inputs: Error_Attribute_Task_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This linesheet already has an attribute task.`)
};

/**
* | output |
* | --- |
* | "This linesheet already has an attribute task." |
*
* @param {Error_Attribute_Task_ExistsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_attribute_task_exists = /** @type {((inputs?: Error_Attribute_Task_ExistsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Attribute_Task_ExistsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_attribute_task_exists(inputs)
});